import repository from "../Repository";

export default {
  async registerConsiderationPerson(personList, screenId) {
    const res = await repository.post(
      `consideration_person_upload`,
      { 
        person_list: personList
      },
      {
        headers: { s: screenId }
      }
    );
    return res;
  }
};
